import { AddCircleFilled, DoNotDisturbOnFilled } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { IconButton } from "../iconButton/IconButton.js";
import { InputNumber } from "../inputNumber/InputNumber.js";
import styles from "./Counter.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Counter({
  min = 0,
  max = 999,
  value = 0,
  label = '',
  step = 1,
  format,
  inputRef,
  className,
  onChange,
  stepMode = 'linear',
  canHandleFloatingValues = false,
  small = true,
  ...inputProps
}) {
  const handleClickIncrement = () => {
    let nextStep = 0;
    if (stepMode === 'linear') {
      nextStep = value + step;
    } else if (stepMode === 'nextStep') {
      nextStep = value + step - value % step;
    }
    if (nextStep <= max || max === null) {
      onChange(nextStep);
    } else {
      onChange(max);
    }
  };
  const handleClickDecrement = () => {
    let nextStep = 0;
    if (stepMode === 'linear') {
      nextStep = value - step;
    } else if (stepMode === 'nextStep') {
      nextStep = value - (value % step || step);
    }
    if (nextStep >= min || min === null) {
      onChange(nextStep);
    } else {
      onChange(min);
    }
  };
  const handleManualInput = value => {
    const parsedValue = canHandleFloatingValues ? Math.round(Number.parseFloat(value.replace(',', '.')) * 10) / 10 : Number.parseInt(value);
    if (parsedValue >= max) {
      onChange(max);
    } else if (parsedValue <= min) {
      onChange(min);
    } else {
      onChange(parsedValue);
    }
  };
  const classes = classnames(className);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.counter,
    children: [/*#__PURE__*/_jsx(IconButton, {
      icon: DoNotDisturbOnFilled,
      className: styles.minusIcon,
      disabled: inputProps.disabled || value <= min,
      onClick: handleClickDecrement,
      role: "minus-icon"
    }), /*#__PURE__*/_jsx(InputNumber, {
      value: value,
      format: format,
      onChange: e => handleManualInput(e.target.value || '0'),
      label: label,
      className: classes,
      inputRef: inputRef,
      textAlign: "center",
      role: "input-value",
      small: small,
      ...inputProps
    }), /*#__PURE__*/_jsx(IconButton, {
      icon: AddCircleFilled,
      className: styles.plusIcon,
      disabled: inputProps.disabled || value >= max,
      onClick: handleClickIncrement,
      role: "plus-icon"
    })]
  });
}